<template>
    <div>
        <h4 class="subtitle is-6 mb-5">
            These statistics show how we have been working to market and sell your property.
        </h4>

        <Notification v-if="! statistics">
            Loading...
        </Notification>

        <div
            v-if="statistics"
            class="columns has-equal-height is-multiline"
        >
            <div class="column is-6 is-3-widescreen">
                <Card :styles="['has-text-centered']">
                    <h5 class="title is-5 mb-5">
                        Matched Applicants

                        <b-tooltip
                            size="is-small"
                            multilined
                        >
                            <b-icon
                                pack="far"
                                icon="question-circle"
                                size="is-small"
                                class="ml-1"
                            />

                            <template #content>
                                <b>Matched</b> – Our applicants matching your property
                                <br />
                                <b>Applicants</b> – Applicants on our database
                            </template>
                        </b-tooltip>
                    </h5>

                    <pie-chart
                        v-if="statistics.SalesApplicantCount"
                        :donut="true"
                        :data="[
                            ['Matched Applicants', statistics.MatchCount || 0],
                            ['Applicants', statistics.SalesApplicantCount],
                        ]"
                        width="200px"
                        height="200px"
                        :colors="['#3273dc', '#dddddd']"
                        legend="bottom"
                        style="margin: 0 auto"
                        :library="{
                            elements: {
                                arc: {
                                    borderColor: 'white',
                                    hoverBorderColor: 'white',
                                },
                            },
                        }"
                    />
                </Card>
            </div>
            <div class="column is-6 is-3-widescreen">
                <Card :styles="['has-text-centered']">
                    <h5 class="title is-5 mb-5">
                        Marketing emails sent

                        <b-tooltip
                            label="The number of emails sent to applicants about your property"
                            size="is-small"
                            multilined
                        >
                            <b-icon
                                pack="far"
                                icon="question-circle"
                                size="is-small"
                                class="ml-1"
                            />
                        </b-tooltip>
                    </h5>

                    <div class="aspect-ratio-outer">
                        <div class="aspect-ratio-box">
                            <div class="aspect-ratio-box-inside">
                                {{ statistics.MatchByEmailCount || 0 }}
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
            <div class="column is-6 is-3-widescreen">
                <Card :styles="['has-text-centered']">
                    <h5 class="title is-5 mb-5">
                        Viewings

                        <b-tooltip
                            multilined
                            size="is-small"
                        >
                            <b-icon
                                pack="far"
                                icon="question-circle"
                                size="is-small"
                                class="ml-1"
                            />

                            <template #content>
                                <b>Completed</b> – The number of viewings completed at your property
                                <br />
                                <b>Scheduled</b> – The number of planned viewings at your property
                            </template>
                        </b-tooltip>
                    </h5>

                    <pie-chart
                        :donut="true"
                        :data="[
                            ['Viewings completed', statistics.ViewingCompletedCount || 0],
                            ['Viewings scheduled', statistics.ViewingScheduledCount || 0],
                        ]"
                        width="200px"
                        height="200px"
                        :colors="['#3273dc', '#dddddd']"
                        :label="['111', '222']"
                        legend="bottom"
                        style="margin: 0 auto"
                        :library="{
                            elements: {
                                arc: {
                                    borderColor: 'white',
                                    hoverBorderColor: 'white',
                                },
                            },
                        }"
                    />
                </Card>
            </div>
            <div class="column is-6 is-3-widescreen">
                <Card :styles="['has-text-centered']">
                    <h5 class="title is-5 mb-5">
                        Offers

                        <b-tooltip
                            size="is-small"
                            label="The number of offers made on your property"
                            multilined
                        >
                            <b-icon
                                pack="far"
                                icon="question-circle"
                                size="is-small"
                                class="ml-1"
                            />
                        </b-tooltip>
                    </h5>

                    <div class="aspect-ratio-outer">
                        <div class="aspect-ratio-box">
                            <div class="aspect-ratio-box-inside">
                                {{ statistics.SalesOffersCount || 0 }}
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Notification from '../components/Notification';
import Card from '../components/Card';

export default {
    components: {
        Notification,
        Card,
    },

    computed: {
        ...mapState('salesPropertyStatistics', [
            'statistics',
        ]),
    },

    mounted() {
        this.$store.dispatch('salesPropertyStatistics/getStatistics', this.$route.params.id);
    },
};
</script>
